import {getJson, postJson} from '@/util/ajaxUtils';

const custom = {noAuth: true, throwError: true, showErrorNotification: false};

/** open 接口共用的 App Info Token */
export const OPEN_APP_INFO_HEADERS = {
    'X-App-Info-Token': '81413242f6ee525105c44dd30229743033dabef569e0ccc2d95ef85ce3b3c7e0',
};

export function openGet(url, config) {
    return getJson(url, {
        custom,
        ...config,
    });
}

export function openPost(url, config) {
    return postJson(url, {
        custom,
        ...config,
    });
}
